export enum QueryParam {
  STATE = 'state',
  SHOP = 'shop',
}
